import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import styled, { css } from 'styled-components'
import { up } from 'styled-breakpoints'

import getDefaultOptions from '../../utils/default-options'

const Wrapper = styled.article`
  display: grid;
  grid-template:
    'image' min-content
    'name' min-content
    'desc' min-content
    / auto;
  gap: ${({ theme }) => theme.spacers.normal};
  align-items: center;
  justify-items: center;

  ${up('small')} {
    grid-template:
      'image name' min-content
      'image desc' min-content
      / min-content auto;
    justify-items: flex-start;
  }
`

const Image = styled(Img)`
  grid-area: image;
  gap: ${({ theme }) => theme.spacers.normal};
  border-radius: 50%;
`

const Name = styled.header`
  ${({ theme }) => css`
    grid-area: name;
    font-family: ${theme.fontFamily.heading};
  `}
`

const Desc = styled.p`
  grid-area: desc;
  margin: 0;
`

export default function Instructor() {
  const { sitePlugin, authorLogo } = useStaticQuery(graphql`
    query {
      sitePlugin(name: { eq: "@babelcoder/gatsby-theme-courses" }) {
        pluginOptions {
          instructor {
            name
            desc
          }
        }
      }
      authorLogo: imageSharp(original: { src: { regex: "/author/" } }) {
        fixed(width: 150, height: 150) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
  `)
  const {
    instructor: { name, desc },
  } = getDefaultOptions(sitePlugin.pluginOptions)

  return (
    <Wrapper>
      <Image fixed={authorLogo.fixed}></Image>
      <Name>{name}</Name>
      <Desc>{desc}</Desc>
    </Wrapper>
  )
}
